module.exports = __webpack_public_path__ + "img/feat-gain-customer-insights.f6af73c9.svg";